import { App } from "vue-components-library/dist/src/services/Workspaces/Workspaces.service.types";

import { getUsersEmsAgencies, IUser } from "@/Login/services";
import { actions } from "@/Login/store/Login.Actions";
import { IAuthorizationToken } from "@/Login/services";

const state = getDefaultLoginState();

export function getDefaultLoginState() {
  return {
    errorMessage: "",
    usernameError: "",
    passwordError: "",
    isLoading: false,
    auth: {
      token: localStorage.getItem("jwt") || "",
      expirationDate: ""
    },
    user: JSON.parse(localStorage.getItem("user") || "null"),
    selectedEMSAgency: null,
    globalAdminAgencies: [],
    workspace: {
      app: undefined
    }
  };
}

const getters = {
  authToken: (state: any) => state.auth.token,
  EMSAgencies: (state: any) => {
    if (state.globalAdminAgencies.length > 0) {
      return state.globalAdminAgencies;
    }
    return getUsersEmsAgencies(state.user);
  },
  user: (state: any) => state.user,
  isAdmin: (state: any) => !!state?.selectedEMSAgency?.admin || !!state?.user?.isAdmin,
  selectedEMSAgency: (state: any) => state.selectedEMSAgency,
  workspaceApp: (state: any) => state.workspace.app
};

const mutations = {
  SET_GENERAL_ERROR(state: any, message: string) {
    state.errorMessage = message;
  },
  SET_USERNAME_ERROR(state: any, message: string) {
    state.usernameError = message;
  },
  SET_PASSWORD_ERROR(state: any, message: string) {
    state.passwordError = message;
  },
  SET_LOADING(state: any, message: string) {
    state.isLoading = message;
  },
  CLEAR_ERRORS(state: any) {
    state.errorMessage = "";
    state.usernameError = "";
    state.passwordError = "";
  },
  SET_AUTH(state: any, authToken: IAuthorizationToken) {
    state.auth = authToken;

    window.localStorage.setItem("jwt", authToken.token);
  },
  SET_USER(state: any, user: IUser) {
    state.user = user;

    localStorage.removeItem("selectedEMSAgency");
    window.localStorage.setItem("user", JSON.stringify(user));
  },
  SET_AGENCY(state: any, agency: any) {
    state.selectedEMSAgency = agency;

    window.localStorage.setItem("selectedEMSAgency", JSON.stringify(agency));
  },
  RESET_STATE(state: any) {
    localStorage.removeItem("jwt");
    localStorage.removeItem("user");
    localStorage.removeItem("selectedEMSAgency");

    Object.keys(localStorage)
      .filter(key => key.endsWith("Filters"))
      .forEach(key => localStorage.removeItem(key));

    const initialState: any = getDefaultLoginState();

    Object.keys(initialState).forEach(key => {
      state[key] = initialState[key];
    });
  },
  SET_GLOBAL_ADMIN_AGENCIES(state: any, globalAdminAgencies: any) {
    state.globalAdminAgencies = globalAdminAgencies;
  },
  SET_WORKSPACE_APP(state: any, workspaceApp: App) {
    state.workspace.app = workspaceApp;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
